import { render } from "./Nav.vue?vue&type=template&id=47ca561c&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"

import "./Nav.vue?vue&type=style&index=0&id=47ca561c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47ca561c"

export default script